/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { JobOutcomeTriggerType } from "./JobOutcomeTriggerType";
import { JobOutcomeTriggerAudience } from "./JobOutcomeTriggerAudience";
export const JobOutcomeTriggerDetails = core.serialization.object({
    type: JobOutcomeTriggerType,
    audience: JobOutcomeTriggerAudience.optional(),
});
